import { IFinancialSummary } from "../../../model/respone/financial/IFinancialSummary";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eFinancialActionTypeDefine = {
    /** Bắt đầu vòng lặp poll số dư mỗi 60s (dispatch khi vào trang đăng ký). */
    LOAD_START: undefined as undefined,
    LOAD_SUCCESS: {} as IFinancialSummary,
    LOAD_ERROR: "" as string,
};

export const eFinancialActionTypeIds = generateActionTypeIds(eFinancialActionTypeDefine, "FINANCIAL");

export type IFinancialActions = IGenericActionType<typeof eFinancialActionTypeDefine, "FINANCIAL">;
